import React from 'react'
import {Link} from 'react-router-dom'

// Intro + mission are adapted from the old hacklab-website repo's About.js —
// kept the "empower students through hands-on experience" / "learning by
// doing" framing, dropped everything specific to the old Finance/
// Entrepreneurship challenge format (that program doesn't exist anymore).
// "What We Do" references the 4 real activities instead, without repeating
// their full descriptions (those live in ActivitiesSection on the homepage).
export default function About() {
    return (
        <div className='px-4 py-20 mx-auto max-w-4xl lg:py-28'>
            <h1 className='text-4xl font-bold text-light font-display lg:text-6xl'>About Us</h1>
            <p className='mt-3 text-xl italic text-dark-300 font-serif-display'>ideas in motion.</p>

            <p className='mt-10 text-lg leading-relaxed text-light lg:text-xl'>
                theHackLab is a student association born in 2024 at Bocconi University, with one idea driving everything we do: push the entrepreneurial limits of students who want to build, not just study.
            </p>

            <h2 className='mt-14 text-2xl font-bold text-light font-display lg:text-3xl'>Mission</h2>
            <p className='mt-4 text-lg leading-relaxed text-dark-300 lg:text-xl'>
                Our mission is to empower students through hands-on experience in entrepreneurship, while fostering a collaborative environment where good ideas turn into real projects. We believe in learning by doing — connecting members with founders, alumni, and industry professionals, and giving them the practical tools to bridge classroom knowledge with the real world.
            </p>

            <h2 className='mt-14 text-2xl font-bold text-light font-display lg:text-3xl'>What We Do</h2>
            <p className='mt-4 text-lg leading-relaxed text-dark-300 lg:text-xl'>
                Throughout the year, we run Build Nights, Workshops, Speaker Sessions, and our Idea Showcase &amp; Feedback Session — regular, low-pressure touchpoints for anyone who wants to build something, learn a real skill, or just meet people doing the same.
                {' '}
                <Link to='/' className='font-semibold underline transition-colors text-light hover:text-accent'>See what's coming up</Link>.
            </p>

            <div className='flex justify-center mt-16'>
                <a href='mailto:as.hacklab@unibocconi.it' className='px-8 py-3 text-base font-semibold rounded-full btn-sweep'>Get Involved</a>
            </div>
        </div>
    )
}
